import moment from 'moment-timezone';
import Constants from 'core/constants';

export const isDateObj = (date) => moment.isMoment(date);
export const formatDate = (date, format) => moment(date).format(format);

export const getStartOfMonth = () => moment().startOf('month');
export const getStartOfDay = () => moment().startOf('day');
export const getSelectedIndexByRangeType = (rangeType) => {
  return Constants.datePickerButtons.find(
    (button) => button.rangeType === rangeType
  ).selected;
};
